import { render, staticRenderFns } from "./mooringTest-type-setting.vue?vue&type=template&id=648549fa&scoped=true"
import script from "./mooringTest-type-setting.vue?vue&type=script&lang=js"
export * from "./mooringTest-type-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648549fa",
  null
  
)

export default component.exports